export enum IntegrationSourceParam {
  SLACK = '0',
  MS_TEAMS = '1',
  JIRA = '2',
  LINEAR = '3',
  ASANA = '4',
  PRODUCTBOARD = '5',
  CLICKUP = '6',
  ROADMUNK = '7',
  SHORTCUT = '8',
  MONDAY = '9',
  WRIKE = '10',
  SALESFORCE = '11',
  HUBSPOT = '12',
  MICROSOFT_DYNAMICS = '13',
  INTERCOM = '14',
  GONG = '15',
  ZENDESK = '16',
  ZOHO_SPRINTS = '17',
  PIPEDRIVE = '18',
  CLARI_COPILOT = '19',
  ZOOM = '20',
}

export enum IntegrationCategoryParam {
  COMMUNICATION = '0',
  PRODUCT_ROADMAPPING = '1',
  PROJECT_MANAGEMENT = '2',
  CRM = '3',
  SUPPORT = '4',
  CALL_TRANSCRIPTION = '5',
}

export enum IntegrationsCaseParam {
  ALL_USE_CASES = '0',
  VOICE_OF_CUSTOMERS = '1',
  PRODUCT_GAPS = '2',
  NOTIFICATIONS = '3',
  WIN_LOSS = '4',
  BATTLE_CARDS = '5',
}

export enum IntegrationMethod {
  API_KEY = 'API_KEY',
  OAUTH = 'OAUTH',
}
